import { formatHtml } from "@trumpf/ux.common-storybook";
import { AllResultsTemplate } from "./all-results.templates";

export default {
    title: "Website/Page Templates/Search/Search Results Sliders/All Results",
    render: AllResultsTemplate.bind({}),
    tags: ["autodocs"],
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const AllResults = {};
